// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__MpN1E","checkboxCol":"Table_checkboxCol__14qdj","emailCol":"Table_emailCol__2oNpm","actionCol":"Table_actionCol__3giwp"};